/** Admin-only site preview: see member CTAs vs prospect paywall copy. */
export const ADMIN_VIEW_KEY = 'cfa-admin-view-as';
export const ADMIN_VIEW_MEMBER = 'member';
export const ADMIN_VIEW_PROSPECT = 'prospect';
export const ADMIN_VIEW_EVENT = 'cfa-admin-view-as';

export function getAdminViewAs() {
  try {
    const raw = String(window.localStorage.getItem(ADMIN_VIEW_KEY) || '')
      .trim()
      .toLowerCase();
    return raw === ADMIN_VIEW_PROSPECT ? ADMIN_VIEW_PROSPECT : ADMIN_VIEW_MEMBER;
  } catch {
    return ADMIN_VIEW_MEMBER;
  }
}

export function setAdminViewAs(mode) {
  const next = mode === ADMIN_VIEW_PROSPECT ? ADMIN_VIEW_PROSPECT : ADMIN_VIEW_MEMBER;
  try {
    window.localStorage.setItem(ADMIN_VIEW_KEY, next);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event(ADMIN_VIEW_EVENT));
  } catch {
    /* ignore */
  }
  return next;
}

export function isProspectPreview(viewAs) {
  return viewAs === ADMIN_VIEW_PROSPECT;
}
